export function OneOf<TValue>(value: TValue, ...values: TValue[]): boolean {
	return values.some(x => x === value);
}

export function NotOneOf<TValue>(value: TValue, ...values: TValue[]): boolean {
	return values.every(x => x !== value);
}
